/**
 * Achievement unlock card: bigger than a toast because unlocking "Century"
 * should feel like a moment, not a notification. One at a time from the
 * queue in taskStats; auto-dismisses, click dismisses sooner.
 */
import { useEffect } from "react";
import { Trophy } from "lucide-react";
import { useTaskStats } from "@/data/taskStats";
import s from "./AchievementPop.module.css";

const SHOW_MS = 4_000;

export function AchievementPops() {
  const current = useTaskStats((st) => st.popQueue[0]);
  const shiftPop = useTaskStats((st) => st.shiftPop);

  useEffect(() => {
    if (!current) return;
    const t = setTimeout(shiftPop, SHOW_MS);
    return () => clearTimeout(t);
  }, [current, shiftPop]);

  if (!current) return null;
  return (
    <div className={s.overlay} role="status" aria-live="polite" onClick={shiftPop}>
      <div className={s.card} key={current.key}>
        <span className={s.icon}>
          <Trophy size={22} />
        </span>
        <span className={s.kicker}>Achievement unlocked</span>
        <span className={s.title}>{current.title}</span>
        <span className={s.desc}>{current.description}</span>
      </div>
    </div>
  );
}
